/**
 * Origin of an accommodation confirmation row.
 *
 * - `Legacy` — authored in CRM the way it always was (default for every
 *   pre-existing row, backfilled by migration).
 * - `Erp` — a read-only mirror of an ERP-owned taxation record, kept in sync
 *   by the ERP→CRM accommodation taxation sync (CRMDEV-6721 / ERP-291). Rows
 *   with this source must not be edited from the CRM UI.
 */
export enum AccommodationConfirmationSource {
  Legacy = "legacy",
  Erp = "erp"
}
